window.addEventListener('scroll',()=>{
  const nav=document.getElementById('fnav');
  if(nav) nav.classList.toggle('scrolled', window.scrollY > 80);
});
/* ═══════════════════════════════
   SCROLL ANIMATIONS ENGINE
   Apple-inspired reveal system
   ═══════════════════════════════ */
document.addEventListener("DOMContentLoaded",function(){
  if(!("IntersectionObserver" in window)) return;

  // Note: "anim-ready" class is added via inline <script> in HTML head
  // (before any content renders) to prevent FOUC. No need to add it here.

  /* ── Auto-stagger: find groups of elements and assign delay classes ── */
  function staggerChildren(parentSel, childSel){
    document.querySelectorAll(parentSel).forEach(function(parent){
      var kids = parent.querySelectorAll(childSel);
      kids.forEach(function(kid, i){ if(i<8) kid.classList.add("d"+(i+1)); });
    });
  }

  // Step cards in "How it works"
  staggerChildren(".sg", ".sc");
  // USP feature cards
  staggerChildren(".usp-track", ".uf");
  // Lifestyle image cards
  staggerChildren(".lg", ".lc");
  // FAQ items
  staggerChildren(".fl", ".fi");
  // Problem points
  staggerChildren(".prob", ".pp");
  // Spec rows (annotated section) — use tight inline delays (10 rows > 8 delay classes)
  document.querySelectorAll(".annotated .specs").forEach(function(specs){
    var rows = specs.querySelectorAll(".sr");
    rows.forEach(function(row, i){ row.style.transitionDelay = (i * 0.04) + "s"; });
  });
  // Pick section stagger
  document.querySelectorAll(".pick").forEach(function(pick){
    var details = pick.querySelector(".pick-details"); if(details) details.classList.add("d2");
  });
  // CTA repeat stagger
  document.querySelectorAll(".cta-repeat").forEach(function(cta){
    var h = cta.querySelector("h2"); if(h) h.classList.add("d1");
    var p = cta.querySelector("p"); if(p) p.classList.add("d2");
    var b = cta.querySelector(".btn"); if(b) b.classList.add("d3");
  });
  // Footer stagger
  document.querySelectorAll(".foot").forEach(function(foot){
    var logo = foot.querySelector(".foot-logo"); if(logo) logo.classList.add("d1");
    var social = foot.querySelector(".foot-social"); if(social) social.classList.add("d2");
    var nav = foot.querySelector(".foot-nav"); if(nav) nav.classList.add("d3");
  });

  /* ── Collect ALL animatable elements ── */
  var allTargets = document.querySelectorAll(
    ".fade-in, .slide-up, .slide-left, .slide-right, .scale-in, .blur-in, .lift-in, "+
    ".sc, .uf, .lc, .fi, .pp, .deep-img, .isize-badge, .pick-img, "+
    ".cta-repeat h2, .cta-repeat p, .cta-repeat .btn, "+
    ".sr, .foot-logo, .foot-social, .foot-nav, .trust-icons-dk, .pick-details"
  );

  /* ── Observer with generous rootMargin for early trigger ── */
  var obs = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        e.target.classList.add("visible");
        obs.unobserve(e.target);
      }
    });
  }, {
    threshold: 0.08,
    rootMargin: "0px 0px -40px 0px"
  });

  allTargets.forEach(function(t){ obs.observe(t); });

  /* ── Safety net: force everything visible after 4s (slow connections) ── */
  /* Exclude .sr (spec rows) — they animate when the spec toggle opens */
  setTimeout(function(){
    allTargets.forEach(function(el){
      if(!el.classList.contains("sr")) el.classList.add("visible");
    });
  }, 4000);

  /* ── Parallax-like subtle shift on hero image (desktop only, passive) ── */
  if(window.innerWidth >= 768){
    var heroImg = document.querySelector(".hero .hi img, .hero .hi picture");
    if(heroImg){
      var ticking = false;
      window.addEventListener("scroll", function(){
        if(!ticking){
          ticking = true;
          requestAnimationFrame(function(){
            var scrollY = window.pageYOffset;
            if(scrollY < 800){
              heroImg.style.transform = "translateY("+(scrollY * 0.08)+"px) scale(1.03)";
            }
            ticking = false;
          });
        }
      }, {passive: true});
      heroImg.style.transition = "transform 0s";
      heroImg.style.willChange = "transform";
    }
  }
});

/* ═══════════════════════════════
   SMOOTH SCROLL FOR CTA BUTTONS
   ═══════════════════════════════ */
document.addEventListener("click",function(e){
  var t=e.target.closest("[data-scroll-to]");
  if(!t) return;
  e.preventDefault();
  var sel=t.getAttribute("data-scroll-to");
  var el=document.querySelector(sel);
  if(el){
    // Account for sticky nav height
    var navH=document.getElementById("fnav");
    var offset=navH?navH.offsetHeight+12:60;
    var top=el.getBoundingClientRect().top+window.pageYOffset-offset;
    window.scrollTo({top:top,behavior:"smooth"});
  }
  // Fire analytics event
  var evt=t.getAttribute("data-event");
  if(evt) trackEvent(evt);
});

/* ═══════════════════════════════
   ANALYTICS EVENT TRACKING
   ═══════════════════════════════ */
function trackEvent(name,data){
  // Push to dataLayer (GTM compatible) or custom analytics
  if(window.dataLayer){
    window.dataLayer.push({event:name,eventData:data||{}});
  }
  // Also log for debugging
  if(window.console && window.console.log){
    console.log("[Tryggve Event]",name,data||"");
  }
}

// Track funnel: page view
trackEvent("page_view",{page:"landing"});

/* ═══════════════════════════════
   MOBILE STICKY CTA BAR
   ═══════════════════════════════ */
(function(){
  var sticky=document.getElementById("stickyCta");
  if(!sticky) return;
  var hero=document.getElementById("s-hero");
  var signup=document.getElementById("s-signup");
  var ticking=false;

  function update(){
    var scrollY=window.pageYOffset||document.documentElement.scrollTop;
    var heroGone=hero?hero.getBoundingClientRect().bottom<0:scrollY>500;
    var nearSignup=signup?signup.getBoundingClientRect().top<180&&signup.getBoundingClientRect().bottom>0:false;
    if(heroGone&&!nearSignup){sticky.classList.add("show")}else{sticky.classList.remove("show")}
    ticking=false;
  }

  function onScroll(){
    if(!ticking){ticking=true;requestAnimationFrame(update)}
  }

  window.addEventListener("scroll",onScroll,{passive:true});
  window.addEventListener("touchmove",onScroll,{passive:true});
  window.addEventListener("resize",onScroll,{passive:true});
  update();
})();

/* ═══════════════════════════════
   SIGNUP FORM: KLAVIYO INTEGRATION
   ═══════════════════════════════ */
(function(){
  var KLAVIYO_COMPANY_ID="T8NmFw";

  var form=document.getElementById("signup-form");
  if(!form) return;

  var input=form.querySelector('input[type="email"]');
  var errorEl=document.getElementById("signup-error");
  if(!input) return;

  function showError(msg){
    if(errorEl){errorEl.textContent=msg;errorEl.style.display="block";}
    if(input){input.style.borderColor="var(--orange)";input.setAttribute("aria-invalid","true");}
    trackEvent("signup_error",{reason:msg});
  }

  function clearError(){
    if(errorEl){errorEl.textContent="";errorEl.style.display="none";}
    if(input){input.style.borderColor="";input.removeAttribute("aria-invalid");}
  }

  if(input){
    input.addEventListener("input",function(){
      if(input.value.trim()) clearError();
    });
  }

  form.addEventListener("submit",function(e){
    e.preventDefault();
    var email=(input&&input.value||"").trim();

    if(!email){
      showError("Ange din e-postadress");
      if(input) input.focus();
      return;
    }

    var valid=/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if(!valid){
      showError("Ange en giltig e-postadress");
      if(input) input.focus();
      return;
    }

    clearError();
    trackEvent("signup_submit");

    var btn=form.querySelector("button[type='submit']");
    if(btn){btn.disabled=true;btn.textContent="Skickar...";}

    function showSuccess(){
      trackEvent("signup_success",{email_domain:email.split("@")[1]});

      /* ── Meta Pixel Lead-event ──
         Shopify Facebook App laddar fbevents.js + initierar fbq() i main thread.
         Vi anropar fbq('track','Lead') direkt härifrån vid lyckad signup.
         fbq() hashar email automatiskt — skicka klartext (lowercase, trimmed).
         Gate:at på marketing-samtycke via Shopify Customer Privacy API (Consentmo). */
      if(typeof window.fbq==="function"){
        var hasMarketingConsent=false;
        try{
          if(window.Shopify&&window.Shopify.customerPrivacy&&window.Shopify.customerPrivacy.currentVisitorConsent){
            hasMarketingConsent=(window.Shopify.customerPrivacy.currentVisitorConsent().marketing==="yes");
          }
        }catch(e){}
        if(hasMarketingConsent){
          var emailLower=email.trim().toLowerCase();
          try{window.fbq("init","1958419758414148",{em:emailLower});}catch(e){}
          window.fbq("track","Lead",{
            content_name:"Rionell Tryggve Preorder",
            content_category:"Preorder Signup",
            value:0,
            currency:"SEK"
          });
        }
      }

      form.innerHTML=
        '<div style="background:#fff;border:1px solid var(--g200);border-radius:20px;padding:24px 20px;text-align:center">'+
          '<div style="font-weight:800;color:#2e7d32;font-size:18px;margin-bottom:10px">\u2713 Klart</div>'+
          '<div style="color:var(--g500);font-size:14px;line-height:1.55">'+
            'Vi h\u00f6r av oss till <strong>'+email+'</strong> n\u00e4r f\u00f6rsta leveransen n\u00e4rmar sig.'+
          '</div>'+
        '</div>';
    }

    function showErrorMsg(){
      if(btn){btn.disabled=false;btn.textContent="F\u00f6rbest\u00e4ll nu";}
      showError("N\u00e5got gick fel. F\u00f6rs\u00f6k igen.");
    }

    // Klaviyo Client API: Subscribe to list + create profile
    // Uses the Client Subscriptions endpoint (creates profile AND subscribes to list)
    var KLAVIYO_LIST_ID="RU9EVR";
    fetch("https://a.klaviyo.com/client/subscriptions/?company_id="+KLAVIYO_COMPANY_ID,{
      method:"POST",
      headers:{"Content-Type":"application/json","revision":"2024-02-15"},
      body:JSON.stringify({
        data:{
          type:"subscription",
          attributes:{
            profile:{
              data:{
                type:"profile",
                attributes:{
                  email:email,
                  properties:{
                    "Signup Source":"Tryggve Preorder",
                    "Product Interest":"Rionell Tryggve"
                  }
                }
              }
            },
            custom_source:"Tryggve Landing Page"
          },
          relationships:{
            list:{
              data:{
                type:"list",
                id:KLAVIYO_LIST_ID
              }
            }
          }
        }
      })
    }).then(function(r){
      if(r.ok||r.status===201||r.status===202||r.status===409){
        // 202=accepted (subscription queued), 409=already subscribed (all good)
        showSuccess();
      } else {
        showErrorMsg();
      }
    }).catch(function(){
      showErrorMsg();
    });
  });
})();

/* ═══════════════════════════════
   FAQ: KEYBOARD ACCESSIBILITY
   ═══════════════════════════════ */
(function(){
  var questions=document.querySelectorAll(".faq .fi .q");
  questions.forEach(function(q){
    // Make focusable and add keyboard support
    if(!q.getAttribute("tabindex")) q.setAttribute("tabindex","0");
    q.setAttribute("role","button");
    var fi=q.parentElement;
    var isOpen=fi.classList.contains("open");
    q.setAttribute("aria-expanded",isOpen?"true":"false");

    q.addEventListener("keydown",function(e){
      if(e.key==="Enter"||e.key===" "){
        e.preventDefault();
        q.click();
      }
    });

    // Update aria-expanded on toggle
    new MutationObserver(function(){
      q.setAttribute("aria-expanded",fi.classList.contains("open")?"true":"false");
    }).observe(fi,{attributes:true,attributeFilter:["class"]});
  });
})();

